import { render, staticRenderFns } from "./ParagraphFullhtml.vue?vue&type=template&id=c5695b1c&scoped=true&"
import script from "./ParagraphFullhtml.vue?vue&type=script&lang=js&"
export * from "./ParagraphFullhtml.vue?vue&type=script&lang=js&"
import style0 from "./ParagraphFullhtml.vue?vue&type=style&index=0&id=c5695b1c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5695b1c",
  null
  
)

export default component.exports